import MultipleInput from './MultipleInput.vue';

export default MultipleInput;
